<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent content-class="round-2xl")
  v-card
    v-card-title.justify-center
      .text-xl.font-semibold {{ $t('edit_diagnosis') }}
    v-divider
    v-card-text.px-6.neutral700--text
      .text-sm.font-semibold.mt-4.my-2 {{ $t('diagnosis') }}
      diagnosis-field-dropdown(:parentDiagnosis="parentDiagnosis" :leadPid="leadPid" isIndependent @updated="onDiagnosisUpdated($event)")
    v-divider.mt-6
    v-card-actions.px-6.py-3
      v-btn.button-md.neutral700--text.px-0(text @click="showDialog = false") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(:loading="isLoading" color="neutral700" depressed dark @click="onSave") {{ $t('save') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DiagnosisFieldDropdown from '@/components/clinic/consultation/diagnosis/DiagnosisFieldDropdown.vue'

export default {
  components: {
    DiagnosisFieldDropdown,
  },
  props: {
    open: {
      type: Boolean,
    },
    top: {
      type: Boolean,
    },
    leadPid: {
      type: String, 
      required: true
    },
    parentDiagnosis: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => ({
    isLoading: false,
    selectedDiagnoses: []
  }),
  mounted () {
    this.selectedDiagnoses = [...this.parentDiagnosis]
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    diagnosisPayload() {
      return {
        diagnoses: this.selectedDiagnoses
      }
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    onDiagnosisUpdated (diagnosis) {
      this.selectedDiagnoses = diagnosis
    },
    async onSave () {
      try {
        this.isLoading = true
        await this.$axios.patch(`/clinics/${this.company.slug}/consultations/${this.leadPid}`, this.diagnosisPayload)
        this.$emit('updated', this.selectedDiagnoses)
        this.showMessage(['success', this.$t('success_message.successfully_updated')])
        this.showDialog = false
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
  }
}
</script>